/* Copyright (c) 2009 Mustafa OZCAN (http://www.mustafaozcan.net)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 * Version: 1.0.4
 * Requires: jquery.1.3+
 *
 * History:
 *
 * 1.04:
 * Additional css suggested to prevent table data from scrolling above header.
 * Example:
 *    padding-top: (value);
 *    background-color: white;
 *
 * 1.03:
 * Removed IE6 check using jQuery.browser, since jQuery.browser has been removed
 * in jQuery 1.9.
 */
function stripHash(el) {
  return el.substring(1);
}

function resetHeader(fixedID, $tbl, $header) {
  var $fixedHeader = $(fixedID);
  $fixedHeader.css({ position: "fixed", top: "0", left: $tbl.offset().left - $(window).scrollLeft() });
  var fixedPaddingTop = parseInt($fixedHeader.css("padding-top"));
  var sctop = $(window).scrollTop();
  var elmtop = $tbl.offset().top - fixedPaddingTop;
  if (sctop > elmtop && sctop <= elmtop + $tbl.height() - $header.height()) {
    $fixedHeader.show();
  } else {
    $fixedHeader.hide();
  }
}

jQuery.fn.fixedtableheader = function (options) {
  var settings = jQuery.extend(
    { headerrowsize: 1, highlightrow: false, highlightclass: "highlight", tableNumber: 0 },
    options,
  );
  this.each(function (i) {
    var i = settings.tableNumber;
    var $tbl = $(this);
    var $header = $tbl.find("tr:lt(" + settings.headerrowsize + ")");
    var $caption = $tbl.find("caption").clone();
    var headerelement = "th";
    if ($header.find(headerelement).length == 0) headerelement = "td";
    if ($header.find(headerelement).length > 0) {
      var $clonedHeader = $header.clone(true, true);

      // Copy widths from header, to be applied to $clonedHeader
      var widths = [];
      $header.find(headerelement).each(function () {
        widths.push($(this).outerWidth());
      });
      $clonedHeader.find(headerelement).each(function (i, el) {
        $(this).css("width", widths[i]);
      });

      var fixedID = "#fixedtableheader" + i;

      $(fixedID).remove();
      $(window).off("scroll." + stripHash(fixedID));
      $(window).off("resize." + stripHash(fixedID));

      var tblwidth = GetTblWidth($tbl);

      var $clonedTable = $tbl.clone().empty();
      $clonedTable.append($caption).append($clonedHeader).width(tblwidth);

      // Add 2 pixels to wrapper width to hide table border in IE
      var wrapperWidth = tblwidth + 2;
      var $wrapper = $("<div/>")
        .attr("id", stripHash(fixedID))
        .css({ position: "fixed", top: "0", left: $tbl.offset().left })
        .append($clonedTable)
        .width(wrapperWidth)
        .hide()
        .appendTo($("body"));

      if (settings.highlightrow) {
        $("tr:gt(" + (settings.headerrowsize - 1) + ")", $tbl).hover(
          function () {
            $(this).addClass(settings.highlightclass);
          },
          function () {
            $(this).removeClass(settings.highlightclass);
          },
        );
      }
      $(window).on("scroll." + stripHash(fixedID), function () {
        resetHeader(fixedID, $tbl, $header);
      });
      resetHeader(fixedID, $tbl, $header);
    }
  });
  function GetTblWidth($tbl) {
    var tblwidth = $tbl.outerWidth();
    return tblwidth;
  }
};
